import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import Media from 'react-media';

import HeaderBanner from '../Main/services/HeaderBanner';
import FindUs from '../Main/contact/FindUs';
import ContactUs from '../Footer/ContactUs';

const Contact = ({ data }) => {
  const hreflang = data.node_locale === 'fr' ? 'en' : 'fr';

  return (
    <div>
      <Helmet>
        <html lang={data.node_locale} />
        <title>{`Offshore Services - ${data.contactTitle}`}</title>
        <meta name="description" content={data.metaDescription} />
        <link
          rel="alternate"
          hreflang={hreflang}
          href={`https://www.offshoreservices.fr/${hreflang}/contact/`}
        />
      </Helmet>
      <Media query={{ minWidth: 768 }}>
        {matches =>
          matches ? (
            <div style={{ marginBottom: 195 }}>
              <HeaderBanner
                title={data.contactTitle}
                image={data.headerImage}
              />
            </div>
          ) : (
            <div style={{ marginBottom: 215 }}>
              <HeaderBanner
                title={data.contactTitle}
                image={data.headerImage}
              />
            </div>
          )
        }
      </Media>
      <div className="container">
        <FindUs
          title={data.findUsBannerTitle}
          address={data.findUsBannerAddress}
        />
      </div>
      <ContactUs locale={data.node_locale} />
    </div>
  );
};

Contact.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Contact;



// WEBPACK FOOTER //
// ./src/components/Pages/Contact.js